import { apiClient } from './apiClient';

export interface SpatialLayerInfo {
  type: string;
  count: number;
  has_entities: boolean;
}

export interface SpatialLayersResponse {
  layers: SpatialLayerInfo[];
  bbox: number[] | null;
  center: number[] | null;
}

export interface SpatialFeatureDetail {
  id: number;
  layer_type: string;
  feature_idx: number;
  properties: Record<string, any>;
  entity_id: string | null;
  geojson: Record<string, any>;
}

export const spatialApi = apiClient.injectEndpoints({
  endpoints: (builder) => ({
    getSpatialLayers: builder.query<SpatialLayersResponse, string>({
      query: (siteId) => ({
        url: `/api/v1/spatial/sites/${siteId}/layers`,
        method: 'GET',
      }),
      keepUnusedDataFor: 300,
    }),

    getSpatialFeatureDetail: builder.query<
      SpatialFeatureDetail,
      { siteId: string; featureId: number }
    >({
      query: ({ siteId, featureId }) => ({
        url: `/api/v1/spatial/sites/${siteId}/features/${featureId}`,
        method: 'GET',
      }),
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetSpatialLayersQuery,
  useLazyGetSpatialLayersQuery,
  useGetSpatialFeatureDetailQuery,
  useLazyGetSpatialFeatureDetailQuery,
} = spatialApi;
